import { DevTools } from 'jotai-devtools';
import { ActionIcon, Affix, Code, ScrollArea, rem } from 'ui';
import { useDisclosure } from 'ui/Hooks';
import { IconGivebacks } from 'ui/Icons';

import { useTableContext } from '../table.context';

const TableDebugger = () => {
  const [opened, handlers] = useDisclosure(false);

  const ctx = useTableContext();
  // Don't return on a build mode
  if (import.meta.env.PROD) return null;
  return (
    <>
      <DevTools store={ctx.atomStore} />
      <Affix position={{ bottom: rem(20), right: rem(80) }} withinPortal zIndex={202}>
        <ActionIcon onClick={handlers.toggle} color={!opened ? 'cobalt' : 'tangerine'}>
          <IconGivebacks />
        </ActionIcon>
      </Affix>
      {opened && (
        <Affix
          position={{ bottom: rem(20), right: rem(25) }}
          withinPortal={false}
          style={{ border: '2px solid blue', borderRadius: rem(5) }}
        >
          <Code block mt={5} bg="white">
            <ScrollArea.Autosize mah="800px" maw="800px">
              {JSON.stringify(ctx, null, 2)}
            </ScrollArea.Autosize>
          </Code>
        </Affix>
      )}
    </>
  );
};

export { TableDebugger };
